import { FiEdit2, FiTrash2 } from 'react-icons/fi';

interface Category {
  id: string;
  name: string;
  guides?: any[]; // We're not using this in the table display
}

interface CategoryTableProps {
  categories: Category[];
  onEdit: (category: Category) => void;
  onDelete: (id: string) => void;
}

export default function CategoryTable({ categories, onEdit, onDelete }: CategoryTableProps) {
  if (!categories?.length) {
    return (
      <div className="bg-[#2A2A2A] rounded-lg p-8 text-center text-gray-400">
        No categories found. Create a new category to get started.
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="bg-[#2A2A2A] rounded-lg overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="bg-[#1A1A1A] text-gray-400 text-sm">
              <th className="text-left py-3 px-4">Category Name</th>
              <th className="text-right py-3 px-4">Actions</th>
            </tr>
          </thead>
          <tbody>
            {categories.map((category) => (
              <tr 
                key={category.id} 
                className="border-b border-white/[0.08] hover:bg-[#3a3a3a33] transition-colors"
              >
                <td className="py-3 px-4">
                  <span className="text-white font-medium">{category.name}</span>
                </td>
                <td className="py-3 px-4 text-right">
                  <div className="flex items-center justify-end gap-2">
                    <button 
                      onClick={() => onEdit(category)}
                      className="p-2 hover:bg-white/[0.08] rounded-lg text-gray-400 hover:text-white transition-colors"
                      title="Edit category"
                    >
                      <FiEdit2 size={16} />
                    </button>
                    <button 
                      onClick={() => onDelete(category.id)}
                      className="p-2 hover:bg-white/[0.08] rounded-lg text-gray-400 hover:text-red-400 transition-colors"
                      title="Delete category"
                    >
                      <FiTrash2 size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}